import ApplicationController from './application_controller'

/* Givsum 3.0 vanilla-JS bid submit controller for the item detail page.
 * Kept separate from bid_controller.js so the legacy auction pages are untouched.
 */
export default class extends ApplicationController {
  connect() {
    super.connect()

    if (!window.givsum_user_id) return

    // Buy Now confirm button lives in a modal outside this <form> (content_for
    // :bootstrap_modal_content) — bind it here, scoped by item id since a page can have
    // many bid forms/modals. Not gated on the winner/loser guard below (my_bids_card_v3
    // has no such alerts). Guarded against double-binding across CableReady replacements.
    const auctionItemIdField = this.element.querySelector('input[name="auction_item_id"]')
    const auctionItemId = auctionItemIdField && auctionItemIdField.value
    if (auctionItemId) {
      const confirmBtn = document.querySelector(`#buyNowConfirmModal_${auctionItemId} .js-confirm-buy-now`)
      if (confirmBtn && confirmBtn.dataset.auctionBidBound !== 'true') {
        confirmBtn.dataset.auctionBidBound = 'true'
        confirmBtn.addEventListener('click', (e) => this.placeBid(e.target, true))
      }
    }

    // Winner/outbid alerts are siblings of <form>, not descendants.
    const wrapper = this.element.parentElement
    if (!wrapper) return

    const winnerEl = wrapper.querySelector('.bidder_is_current_winner')
    const loserEl = wrapper.querySelector('.bidder_is_not_current_winner')
    const winningField = this.element.querySelector('input[name="winning_user_ids"]')
    if (!winnerEl || !loserEl || !winningField) return

    const winningUserIds = (winningField.value.match(/\d+/g) || []).map(Number)
    const isWinning = winningUserIds.includes(window.givsum_user_id)

    const buyNowUserIdsField = this.element.querySelector('input[name="buy_now_user_ids"]')
    const buyNowUserIds = buyNowUserIdsField ? (buyNowUserIdsField.value.match(/\d+/g) || []).map(Number) : []
    const isBuyNowWinner = buyNowUserIds.includes(window.givsum_user_id)
    const hasOwnBidOnThisItem = auctionItemId ? hasExistingBidOnItem(auctionItemId) : false

    // Only show "outbid" to someone who actually has a bid here (not just !isWinning).
    winnerEl.classList.toggle('d-none', !isWinning)
    loserEl.classList.toggle('d-none', isWinning || !hasOwnBidOnThisItem)

    // Broadcasts always render this with @submitted_bid = whoever just acted, not this
    // viewer — set the text ourselves from this viewer's real win-type instead of trusting it.
    if (isWinning) {
      winnerEl.textContent = isBuyNowWinner
        ? 'You have bought this item!'
        : 'Your bid is leading the auction.'
    } else if (hasOwnBidOnThisItem) {
      loserEl.textContent = 'You have been outbid.'
    }

    // Broadcasts always render disable_bidding: false (shared render) — correct client-side.
    const submitBtn = this.element.querySelector('[data-action*="auction-bid#submit"]')
    if (submitBtn) submitBtn.disabled = isWinning

    this.element.querySelectorAll('[data-action*="bid-counter#decrement"], [data-action*="bid-counter#increment"]')
      .forEach((btn) => { btn.disabled = isWinning })

    // .buy_now_button is a sibling of <form>, so query via `wrapper`, not `this.element`.
    wrapper.querySelectorAll('.buy_now_button').forEach((btn) => {
      btn.classList.toggle('d-none', isBuyNowWinner)
    })
  }

  submit(event) {
    event.preventDefault()
    this.placeBid(event.target, false)
  }

  placeBid(triggerEl, buyNow) {
    triggerEl.disabled = true
    document.body.classList.add('wait')

    const form = this.element

    if (!window.givsum_user_id) {
      triggerEl.disabled = false
      document.body.classList.remove('wait')
      return
    }

    const bidderField = form.querySelector('input[name="bidder_id"]')
    if (bidderField) {
      bidderField.value = window.givsum_user_id
    }

    const buyNowField = form.querySelector('input[name="buy_now"]')
    if (buyNowField) {
      buyNowField.value = buyNow
    }

    // Captured before stimulate() — reads pre-bid state so it can't race the broadcast.
    const auctionItemIdField = form.querySelector('input[name="auction_item_id"]')
    const alreadyHadBidOnThisItem = hasExistingBidOnItem(auctionItemIdField && auctionItemIdField.value)

    this.stimulate('BidReflex#bid').then(() => {
      document.body.classList.remove('wait')
      if (!alreadyHadBidOnThisItem) incrementMyBidsTabCount()
    }).catch(() => {
      document.body.classList.remove('wait')
      triggerEl.disabled = false
    })
  }
}

function hasExistingBidOnItem(auctionItemId) {
  if (!auctionItemId) return true // fail-safe: unknown state, don't risk a wrong increment
  try {
    const myBidsMap = JSON.parse(localStorage.getItem('userBidsMap') || '{}')
    return Boolean(myBidsMap[auctionItemId])
  } catch (e) {
    return true
  }
}

function incrementMyBidsTabCount() {
  const countEl = document.querySelector('#my-bids-tab .tab-count')
  if (!countEl) return
  const match = countEl.textContent.match(/\d+/)
  const current = match ? parseInt(match[0], 10) : 0
  countEl.textContent = `(${current + 1})`
}
